import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "text-left" }
const _hoisted_2 = { class: "text-center" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "text-center" }
const _hoisted_5 = { class: "text-center" }
const _hoisted_6 = { class: "text-center" }
const _hoisted_7 = { class: "text-center" }
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_data_table = _resolveComponent("v-data-table")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, { fluid: "" }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          (_ctx.mode !== 'GeneralLedger')
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "1"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn_icon, {
                    size: "small",
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1))),
                    icon: "$oss-chevron-left"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_v_col, { cols: "10" }, {
            default: _withCtx(() => [
              _createElementVNode("h1", null, "Z de caisse du " + _toDisplayString(_ctx.date) + " - " + _toDisplayString(_ctx.period), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        justify: "center",
        class: "mt-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "10"
          }, {
            default: _withCtx(() => _cache[1] || (_cache[1] = [
              _createElementVNode("h5", { class: "title" }, "Recettes encaissées", -1)
            ])),
            _: 1
          }),
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "10"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, { class: "default_card large" }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_data_table, {
                    headers: _ctx.headers,
                    items: _ctx.incomes,
                    class: "table",
                    "hide-default-footer": ""
                  }, {
                    item: _withCtx((props) => [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_1, [
                          _createElementVNode("b", null, _toDisplayString(props.item.accountableAccount
                                            ? props.item.accountableAccount.description ||
                                              props.item.accountableAccount.name
                                            : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_2, [
                          _createElementVNode("b", null, _toDisplayString(props.item.vatRate !== undefined
                                            ? props.item.vatRate + "%"
                                            : "-"), 1)
                        ]),
                        _createElementVNode("td", _hoisted_3, _toDisplayString(props.item.netAmount
                                            ? _ctx.newCommonFormatCurrency(
                                                  props.item.netAmount,
                                                  undefined,
                                              )
                                            : ""), 1),
                        _createElementVNode("td", _hoisted_4, _toDisplayString(props.item.vatAmount
                                            ? _ctx.newCommonFormatCurrency(
                                                  props.item.vatAmount,
                                                  undefined,
                                              )
                                            : ""), 1),
                        _createElementVNode("td", _hoisted_5, _toDisplayString(props.item.grossAmount
                                            ? _ctx.newCommonFormatCurrency(
                                                  props.item.grossAmount,
                                                  undefined,
                                              )
                                            : ""), 1),
                        _createElementVNode("td", _hoisted_6, _toDisplayString(props.item.freeAmount
                                            ? _ctx.newCommonFormatCurrency(
                                                  props.item.freeAmount,
                                                  undefined,
                                              )
                                            : ""), 1)
                      ])
                    ]),
                    "body.append": _withCtx(() => [
                      _createElementVNode("tr", null, [
                        _cache[2] || (_cache[2] = _createElementVNode("td", null, null, -1)),
                        _cache[3] || (_cache[3] = _createElementVNode("td", { class: "text-right" }, [
                          _createElementVNode("strong", null, "Totaux")
                        ], -1)),
                        _createElementVNode("td", _hoisted_7, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalNetAmount, undefined)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_8, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalVatAmount, undefined)), 1)
                        ]),
                        _createElementVNode("td", _hoisted_9, [
                          _createElementVNode("strong", null, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.totalGrossAmount, undefined)), 1)
                        ]),
                        _cache[4] || (_cache[4] = _createElementVNode("td", null, null, -1))
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[5] || (_cache[5] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "4"
                        }, [
                          _createElementVNode("strong", null, "Dont montant offert")
                        ], -1)),
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.freeAmount, undefined)), 1),
                        _cache[6] || (_cache[6] = _createElementVNode("td", null, null, -1))
                      ]),
                      _createElementVNode("tr", null, [
                        _cache[7] || (_cache[7] = _createElementVNode("td", {
                          class: "text-right",
                          colspan: "4"
                        }, [
                          _createElementVNode("strong", null, "Montant payé")
                        ], -1)),
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.newCommonFormatCurrency(_ctx.paidAmount, undefined)), 1),
                        _cache[8] || (_cache[8] = _createElementVNode("td", null, null, -1))
                      ])
                    ]),
                    _: 1
                  }, 8, ["headers", "items"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}